import {
  HOTEL_URL_PARAM_KEYS,
  QueryParamType,
  useParseQueryParams,
} from "@b2bportal/core-utilities";

export const useGetAvailabilityQueryParams = () => {
  //TODO: extend this to get filters that are going to be all optional.
  const params = {
    [HOTEL_URL_PARAM_KEYS.FROM_DATE]: {
      type: QueryParamType.requiredString,
    },
    [HOTEL_URL_PARAM_KEYS.UNTIL_DATE]: {
      type: QueryParamType.requiredString,
    },
    [HOTEL_URL_PARAM_KEYS.ADULTS_COUNT]: {
      type: QueryParamType.requiredNumber,
    },
    [HOTEL_URL_PARAM_KEYS.CHILDREN_AGES]: {
      type: QueryParamType.optionalNumberArray,
    },
    [HOTEL_URL_PARAM_KEYS.PETS_COUNT]: {
      type: QueryParamType.optionalNumber,
    },
    [HOTEL_URL_PARAM_KEYS.ROOMS_COUNT]: {
      type: QueryParamType.optionalNumber,
    },
  };

  return useParseQueryParams(params);
};
